import { getAxiosCounted } from 'pages/api/axios'
import { IBasicCard } from 'constants/types/card.types'
import { formatLectorSingleURL } from 'utils/search/formateCountQuery'
import { CARDS_ON_PAGE } from 'constants/search-data/search-data'
import { ContentType, Key } from 'constants/search-data/lector-single-data'
import { IgetCardsMaterials } from 'constants/types/search.types'
import { IAnyObj, IOptions } from 'constants/types/common.types'
import { LectorSearchURL } from 'constants/search-data/lector-search-data'

const sortByDate = (a: IAnyObj, b: IAnyObj): number => {
  const dateA = a.startDate
  const dateB = b.startDate
  return dateB - dateA
}

const formatData = (arr: any, type: string) =>
  arr.rows.map((item: IBasicCard) => ({ type, isWebinar: type === ContentType.WEBINAR, ...item }))

const getData =
  (lectorId: number): IgetCardsMaterials =>
  async (params, isReset, usedCardsCount) => {
    const formatedQuery = formatLectorSingleURL(
      lectorId as number,
      params[Key.THEMES] as IOptions[],
      params[Key.TYPES] as string[],
      params[Key.DATES] as Date[],
      params[Key.TEXT] as string
    )
    const limit = CARDS_ON_PAGE

    const recieveData = async (query: string) => {
      const offset = isReset ? 0 : (usedCardsCount - 1) * limit
      const url = `${LectorSearchURL.LECTURE_MATERIALS}${query}&limit=${limit}&offset=${offset}`
      return await getAxiosCounted(url)
    }

    const results = await recieveData(formatedQuery)

    return {
      totalPages: results.count / limit,
      allItems: results.rows,
      allCount: results.count,
    }
  }

export { getData }
